import React from 'react';
import { isFunction } from 'lodash';
import { inClientContext } from '../utils';

export const withScript = (getSources) => (Component) =>
    class Wrapper extends React.Component {
        constructor(props) {
            super(props);
            // eslint-disable-next-line react/prop-types
            const { env } = this.props;
            this.sources = getSources(env);

            if (!inClientContext()) {
                return;
            }

            this.promise = Promise.all(
                this.sources.map(
                    (source) =>
                        new Promise((resolve, reject) => {
                            if (this.isLoaded(source)) {
                                return resolve();
                            }

                            const tag = document.createElement('script');
                            tag.type = 'text/javascript';
                            tag.async = false;
                            tag.src = source;
                            tag.addEventListener('load', () => resolve());
                            tag.addEventListener('error', () => reject());
                            document.getElementsByTagName('head')[0].appendChild(tag);
                        })
                )
            );

            this.onLoad = this.onLoad.bind(this);
        }

        isLoaded(source) {
            const scripts = document.getElementsByTagName('script');
            for (let i = 0; i < scripts.length; i++) {
                if (scripts[i].src === source) {
                    return true;
                }
            }
            return false;
        }

        async onLoad(onSuccess, onError) {
            if (!inClientContext()) {
                return;
            }

            try {
                await this.promise;
                if (isFunction(onSuccess)) {
                    onSuccess();
                }
            } catch (error) {
                if (isFunction(onError)) {
                    onError();
                }
            }
        }

        render() {
            return <Component {...this.props} onLoad={this.onLoad} />;
        }
    };

export default withScript;
